import ArrSVG from '@public/icons/btn-arr.svg';
import classNames from 'classnames';
import { AwardProps } from '@/entities/accordion';
import { Document } from '@/entities/document';
import { useMediaQueryDeviceStateValue } from '@/shared/atoms/media-query-device';
import { tp } from '@/shared/lib/typograf';
import Collapse from '../../shared/Collapse';
import SectionDocs from '../../shared/SectionDocs';
import Typografed from '../../shared/Typografed';

export interface AwardsSectionProps {
    title: string;
    awards: AwardProps[];
    documents?: Document[] | [];
}

type Props = React.HTMLAttributes<HTMLElement> & {
    awardsSectionProps: AwardsSectionProps;
};

const AwardsSection = ({ awardsSectionProps, ...props }: Props) => {
    const SECTION_ID = props.id || 'awards';

    return (
        <section {...props} className={classNames('awords__section', props.className)} id={SECTION_ID}>
            <div className="awords__wrapper wrapper">
                <div className="awords__top">
                    <div className="awords__title h3">
                        <Typografed>{awardsSectionProps.title}</Typografed>
                    </div>
                    {awardsSectionProps.documents && awardsSectionProps.documents.length > 0 && (
                        <SectionDocs documents={awardsSectionProps.documents} />
                    )}
                </div>

                <div className="awords__cards">
                    {awardsSectionProps.awards.map((item, i) => (
                        <AwardItem key={i} award={item} />
                    ))}
                </div>
            </div>
        </section>
    );
};

const AwardItem = ({ award }: { award: AwardProps }) => {
    const device = useMediaQueryDeviceStateValue();
    const isTablet = device.includes('tablet');
    const isMobile = device.includes('mobile');
    const isDesktop = device.includes('desktop');
    return (
        <>
            {isDesktop ? (
                <Collapse hover={true} initialCollapsed={true}>
                    <Collapse.Toggler>
                        <div className="awords__card">
                            <div className="aword__card-wrapper">
                                <div className="aword__card-title text-xl">
                                    <Typografed>{award.title}</Typografed>
                                </div>
                                {award.description && (
                                    <Collapse.Content>
                                        <div
                                            className="aword__card-description text-s wysiwyg"
                                            dangerouslySetInnerHTML={{ __html: tp(award.description) }}
                                        ></div>
                                    </Collapse.Content>
                                )}
                            </div>
                            <div className="aword__card-btn__wrapper">
                                <div className="aword__card-btn faq-btn">
                                    <ArrSVG />
                                </div>
                            </div>
                        </div>
                    </Collapse.Toggler>
                </Collapse>
            ) : (
                <Collapse initialCollapsed>
                    <div className="awords__card">
                        <Collapse.Toggler>
                            <div className="aword__card-wrapper">
                                <div className="aword__card-title text-xl">
                                    <Typografed>{award.title}</Typografed>
                                </div>
                                {award.description && (
                                    <Collapse.Content>
                                        <div
                                            className="aword__card-description text-s wysiwyg"
                                            dangerouslySetInnerHTML={{ __html: tp(award.description) }}
                                        ></div>
                                    </Collapse.Content>
                                )}
                            </div>
                            <div className="aword__card-btn__wrapper">
                                <div className="aword__card-btn faq-btn">
                                    <ArrSVG />
                                </div>
                            </div>
                        </Collapse.Toggler>
                    </div>
                </Collapse>
            )}
        </>
    );
};

export default AwardsSection;
